import EllipsisIcon from './component.jsx'
export default EllipsisIcon
